$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  adjustLineupButton();
  modifySignup();
  headerLayout();
});

$(window).on('load', function () {
  contentMarginTop();
  changeSponsorsHtmlTag();
  customizeLanguageDropdown();
});

$(window).on('resize', function () {
  contentMarginTop();
  headerLayout();
});

// Adjust Feature Lineup Button based on available space
function adjustLineupButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

// Calculate content margin top
function contentMarginTop() {
  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      const headerHeight = $('header').outerHeight();
      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + 70 + 'px');
        clearInterval(interval);
      }
    }
  }, 300);
}

// Customize Sign Up
function modifySignup() {
  const signupWidget = $('.emailSignup');
  const inputField = signupWidget.find('.emailInputField');
  const submitButton = signupWidget.find('.emailInputSubmit');
  signupWidget.find('.emailSignupText').replaceWith(`
    <div class="emailSignupTextContainer">       
      <h3>Subscribe to our<br>Email Newsletter</h3>     
    </div>`);
  $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');
  inputField
    .find('.inputFieldTextbox')
    .val('')
    .attr('placeholder', 'Email Address')
    .attr('aria-label', 'Email address');
  submitButton.find('.emailSubmitButton').text('Sign up now!');
}

// Customize Google Translate Language Dropdown
function customizeLanguageDropdown() {
  const span = document.querySelector('.VIpgJd-ZVi9od-xl07Ob-lTBxed span');

  if (document.body.classList.contains('pageIsLoaded') && span) {
    if (span.textContent.trim() !== 'Language') {
      span.textContent = 'Language';
      const container = document.querySelector('.VIpgJd-ZVi9od-xl07Ob-lTBxed');
      if (container) {
        container.style.display = 'block';
      }
      setTimeout(customizeLanguageDropdown, 300);
    }
  } else {
    setTimeout(customizeLanguageDropdown, 300);
  }
}

// Position search and Cart icons for Desktop and Mobile
function headerLayout() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.header-top-icons').prependTo('.header-right-container');
  } else {
    $('.header-top-icons').appendTo('.header-top-inner-container');
  }
}

// Change Sponsors Title HTML Tag
function changeSponsorsHtmlTag() {
  const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
  $('#sponsorsTitleContainer .homepageh1').replaceWith(
    `<h2 class="homepageh1">${sponsorsTitleContent}</h2>`,
  );
}
